import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { useConsentStore } from '../store/consentStore';
import { useAuthStore } from '../store/authStore';
import { initMetaPixel } from '../utils/metaPixel';
import { initClarity, identifyClarityUser } from '../utils/clarity';
import { useCartSync } from '../hooks/useCartSync';
import { StoreEventType, trackStoreEvent } from '../services/trackingService';

export function TrackingManager() {
  const analytics = useConsentStore((s) => s.analytics);
  const marketing = useConsentStore((s) => s.marketing);
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const customerId = useAuthStore((s) => s.customerId);
  const { pathname } = useLocation();
  const lastTrackedPathRef = useRef<string | null>(null);

  useCartSync();

  useEffect(() => {
    if (analytics !== true || lastTrackedPathRef.current === pathname) return;
    lastTrackedPathRef.current = pathname;
    trackStoreEvent({ type: StoreEventType.PageView, path: pathname });
  }, [analytics, pathname]);

  useEffect(() => {
    if (marketing === true) initMetaPixel();
  }, [marketing]);

  useEffect(() => {
    if (analytics === true) initClarity();
  }, [analytics]);

  useEffect(() => {
    if (analytics === true && isAuthenticated && customerId !== null) {
      identifyClarityUser(customerId);
    }
  }, [analytics, isAuthenticated, customerId]);

  return null;
}
